import {useRegisterEvents, useSigma} from "@react-sigma/core";
import {useEffect} from "react";
import {useSubNetworkContext} from "../../contexts/SubNetworkContext";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {NodeData} from "../../types/Types";
import {openGeneCards} from "../ExternalLinks";
import {createRightClickNodeHandler} from "../../utils/nodeMenu";
import {SigmaEventPayload} from "sigma/sigma";


const SubNetworkEventsController = () => {
  const sigma = useSigma();
  const graph = sigma.getGraph();

  const {displayedTerms, setHighlightedTerm} = useSubNetworkContext();
  const { setNodeMenuState } = useTheCellMapContext();

  const registerEvents = useRegisterEvents();

  const preventDefault = (payload: SigmaEventPayload) => {
    payload.preventSigmaDefault();
    payload.event.original.preventDefault();
  }

  /**
   * Initialize common events for all networks.
   */
  useEffect(() => {
    registerEvents({
      doubleClickNode({node, preventSigmaDefault}) {
        preventSigmaDefault(); // Prevent zooming on double-click

        /* Node is added to the graph in GraphDataController as NodeData type with extra label and size properties. */
        const nodeData: NodeData = graph.getNodeAttributes(node) as NodeData;
        openGeneCards(nodeData.e);
      },
      rightClickNode: createRightClickNodeHandler(setNodeMenuState),
      rightClickStage: preventDefault,
      enterNode({node}) {
        displayedTerms.forEach(term => {
          if (term.entrez.includes(+node)) {
            setHighlightedTerm(term);
          }
        })
      },
      leaveNode() {
        setHighlightedTerm(undefined);
      },
    });
  }, [registerEvents, graph, displayedTerms, setNodeMenuState]);

  return null;
};

export default SubNetworkEventsController;
